// extracted by mini-css-extract-plugin
module.exports = {"block":"DetailedSocial_block__pLS77 article-wrapper","title":"DetailedSocial_title__Y0c1E small-links","share":"DetailedSocial_share__FJldm","icon":"DetailedSocial_icon__3D4r3"};